/// <summary>
/// Returns a proxy object that returns the name of T's properties as string.
/// </summary>
export function fields<T>() {
    return new Proxy(
        {},
        {
            get: function (_target, prop, _receiver) {
                return prop;
            },
        }
    ) as {
            [P in keyof T]: P;
        };
};